var _path, _path2, _path3, _path4;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgBudget1(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 30,
    height: 30,
    viewBox: "0 0 30 30",
    fill: "none",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M10.8978 1.6665H2.69263C2.12619 1.6665 1.66699 2.1257 1.66699 2.69214V10.8973C1.66699 11.4637 2.12619 11.9229 2.69263 11.9229H10.8978C11.4642 11.9229 11.9234 11.4637 11.9234 10.8973V2.69214C11.9234 2.1257 11.4642 1.6665 10.8978 1.6665Z",
    stroke: "#AA1A5F",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M27.308 1.6665H19.1029C18.5365 1.6665 18.0773 2.1257 18.0773 2.69214V10.8973C18.0773 11.4637 18.5365 11.9229 19.1029 11.9229H27.308C27.8745 11.9229 28.3337 11.4637 28.3337 10.8973V2.69214C28.3337 2.1257 27.8745 1.6665 27.308 1.6665Z",
    stroke: "#AA1A5F",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M10.8978 18.0767H2.69263C2.12619 18.0767 1.66699 18.5359 1.66699 19.1024V27.3075C1.66699 27.874 2.12619 28.3332 2.69263 28.3332H10.8978C11.4642 28.3332 11.9234 27.874 11.9234 27.3075V19.1024C11.9234 18.5359 11.4642 18.0767 10.8978 18.0767Z",
    stroke: "#AA1A5F",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M27.308 18.0767H19.1029C18.5365 18.0767 18.0773 18.5359 18.0773 19.1024V27.3075C18.0773 27.874 18.5365 28.3332 19.1029 28.3332H27.308C27.8745 28.3332 28.3337 27.874 28.3337 27.3075V19.1024C28.3337 18.5359 27.8745 18.0767 27.308 18.0767Z",
    stroke: "#AA1A5F",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgBudget1);
export default __webpack_public_path__ + "static/media/budget1.5eaabfe4a8565099b11e768d7fbd9abf.svg";
export { ForwardRef as ReactComponent };